import { Link } from 'react-router-dom';

interface MovieCardProps {
  id: number;
  title: string;
  titleEn?: string;
  category: string;
  year: number;
  rating: number;
  poster: string;
  slug: string;
  size?: 'normal' | 'large';
}

export default function MovieCard({ title, titleEn, category, year, rating, poster, slug, size = 'normal' }: MovieCardProps) {
  return (
    <Link
      to={`/article/${slug}`}
      className="group block cursor-pointer"
    >
      <div className={`relative overflow-hidden rounded-lg ${
        size === 'large' ? 'aspect-[2/3]' : 'aspect-[3/4]'
      }`}>
        <img
          src={poster}
          alt={title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

        <div className="absolute top-2 right-2">
          <span className="px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs font-semibold whitespace-nowrap">
            {rating}
          </span>
        </div>

        <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-2 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-300">
          <p className="text-background-50 text-xs line-clamp-2 leading-relaxed">
            点击查看详情
          </p>
        </div>
      </div>

      <div className="mt-2.5">
        <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
          {title}
        </h3>
        {titleEn && (
          <p className="text-xs text-foreground-500 mt-0.5 line-clamp-1">{titleEn}</p>
        )}
        <div className="flex items-center gap-2 mt-1.5">
          <span className="text-xs text-foreground-500">{year}</span>
          <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
          <span className="text-xs text-foreground-500">{category}</span>
        </div>
      </div>
    </Link>
  );
}